import { Button } from 'antd'
import { ColumnType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useState } from 'react'

import {
  BirthType,
  PatientBirthItemDto,
  PregnancyPeriodType
} from 'src/api/requests'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'

export const useBirthColumns = () => {
  const [birthId, setBirthId] = useState('')

  const onCancel = () => {
    setBirthId('')
  }

  const { t } = useLocales()

  const birthTypeOptions = Object.entries(BirthType).map(([_, value]) => ({
    value,
    label: t(`pregnancy.birth_type.${value}`)
  }))

  const pregnancyTypeOptions = Object.entries(PregnancyPeriodType).map(
    ([_, value]) => ({
      value,
      label: t(`pregnancy.period_type.${value}`)
    })
  )

  const columns: ColumnType<PatientBirthItemDto>[] = [
    {
      key: 'birthDate',
      title: `${t('pregnancy.birth_date')}`,
      render: (_, { birthDate }) =>
        birthDate ? dayjs(birthDate).format(dayMonthYearBackSlash) : '-'
    },
    {
      key: 'birthType',
      title: t('pregnancy.birth_type_status'),
      render: (_, { birthType }) =>
        birthTypeOptions?.find((option) => option.value === birthType)?.label ??
        '-'
    },
    {
      key: 'pregnancyPeriodType',
      title: t('pregnancy.period_type_status'),
      render: (_, { pregnancyPeriodType }) =>
        pregnancyTypeOptions?.find(
          (option) => option.value === pregnancyPeriodType
        )?.label ?? '-'
    },
    {
      key: 'newborns',
      title: `${t('pregnancy.newBorns')}`,
      render: (_, { newborns }) =>
        newborns && newborns.length > 0
          ? newborns
              .map((newborn) => `${newborn?.lastName} ${newborn.firstName}`)
              .join(', ')
          : '-'
    },
    {
      key: 'actions',
      align: 'end',
      fixed: 'right',
      render: ({ id }) => (
        <Button type="link" onClick={() => setBirthId(id)}>
          {t('common.see_details')}
        </Button>
      )
    }
  ]

  return {
    columns,
    birthId,
    onCancel
  }
}
